import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';
import i18n from './index';

/**
 * Timestamps in the UI's language. The PATTERN comes from the locale file (`dates.*`), not only the
 * month names, so Spanish reads "21 oct, 15:05" — day before month, 24-hour clock — rather than an
 * English pattern with Spanish words dropped into it.
 *
 * Timestamps only (a tick, an upload, an email sent): those render in the reader's zone. Calendar
 * DATES (a review period) go through `utils/calendarDate`, which reads the UTC day.
 */
export type DatePattern =
  | 'dayTime' | 'dayYear' | 'dayYearTime' | 'monthDay' | 'weekdayTime' | 'weekdayDay' | 'fullDate';

export function dateFnsLocale() {
  return i18n.language === 'es' ? es : undefined;
}

export function formatInstant(value: string | Date, pattern: DatePattern): string {
  const d = typeof value === 'string' ? parseISO(value) : value;
  return format(d, i18n.t(`dates.${pattern}`), { locale: dateFnsLocale() });
}
